import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useLocation } from 'react-router';
import { SmartConfigInstruction } from 'console/smart-config/components/instruction';
import { useNavigate } from 'react-router-dom';
import { useNavigateRoot } from 'shared/hooks/router';
export const SmartConfigRouterInstruction = memo(function SmartConfigRouterInstruction() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const onSend = useCallback((name, password) => {
        navigate('/smart-config/sending', {
            state: { name, password },
        });
    }, []);
    const onCancel = useNavigateRoot();
    return (_jsx(SmartConfigInstruction, { name: state?.name, password: state?.password, onSend: onSend, onCancel: onCancel }));
});
